import AmenityCard from '@/components/AmenityCard/AmenityCard';
import { useAppContext } from '@/contexts/AppContext';
import type { FC } from 'react';

const CommunityAmenitiesSection: FC = () => {
  const { community } = useAppContext();

  return (
    <section className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Community Amenities</h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Enjoy resort-style living with our premium amenities designed for your comfort and
            convenience
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {community.advertisedAmenities?.map((amenity) => (
            <AmenityCard amenity={amenity} key={`community-amenity-${amenity}`} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommunityAmenitiesSection;
